import { useMemo } from "react";
import { useStores } from "stores/setup/use-store";
import CustomMarker from "../Components/CustomMarker";

const useCustomMarkers = () => {
  const {
    dataStores: { forecastChartPageStore, insightAlertStore },
  } = useStores();

  const selectedStationForAlert = insightAlertStore.selectedStationForAlert;
  const isPointSelectionMode = forecastChartPageStore.isPointSelectionMode;

  return useMemo(() => {
    return forecastChartPageStore.stations.map((station) => (
      <CustomMarker
        key={`${station.station_id}-${station.region_id}`}
        station={station}
        selectedStationForAlert={selectedStationForAlert}
        isPointSelectionMode={isPointSelectionMode}
      />
    ));
  }, [
    forecastChartPageStore.stations,
    selectedStationForAlert,
    isPointSelectionMode,
  ]);
};

export default useCustomMarkers;
